import {createApp} from 'vue'
import App from './App.vue'
import {createPinia} from "pinia"
import {router} from "./router/index";
import piniaPersist from 'pinia-plugin-persist'
import mqttTool from "@/utils/mqtt/index"
import mqttTool2 from "@/utils/mqtt/index2"
let store = createPinia() //创建pinia实例
store.use(piniaPersist)

import goto____bootstrap from "./utils/bootstrap";
import batch____import from './utils/imports'
import register____global from "@/utils/registerGlobal";
// import './mock';//接口模拟

// 初始化MQTT
mqttTool.MqttConnection();
mqttTool2.MqttConnection();
/* 初始化vue */
let app = createApp(App);
app.use(store);//状态管理器
app.use(router);//路由加载

batch____import(app);//批量导入组件
goto____bootstrap(); //引导系统初始化
register____global(app); //注册全局方法

app.mount('#app')
